import React, { FC } from 'react';

interface IIconArrowUpProps {
  opacity?: string;
  width?: string;
  height?: string;
}
const IconArrowUp: FC<IIconArrowUpProps> = ({ opacity = '1', height = '9', width = '12' }) => {
  return (
    <svg
      className="inline"
      width={`${width}`}
      height={`${height}`}
      viewBox="0 0 12 9"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10 0.939453L5.707 5.23245L1.414 0.939453L0 2.35345L5.707 8.06045L11.414 2.35345L10 0.939453Z"
        fill="currentColor"
        opacity={`${opacity}`}
      />
    </svg>
  );
};

export default IconArrowUp;
